<template>
    <div :class="cardClass">
        <template v-if="!isLoading">
            <div class="MultiDonutCard__header-bar">
                <div class="MultiDonutCard__header">
                    <slot name="header">
                        <span class="MultiDonutCard__header-text">{{ header }}</span>
                        <RPTooltip
                            v-if="headerTooltip !== ''"
                            class="MultiDonutCard__header-tooltip"
                            :tooltip="headerTooltip"
                        />
                    </slot>
                </div>
                <div class="MultiDonutCard__title-action">
                    <slot name="action"></slot>
                </div>
            </div>
            <div class="MultiDonutCard__content">
                <RPDonutChart
                    v-for="chart in chartData"
                    :key="JSON.stringify(chart)"
                    :chart-data="chart"
                    :show-legend="false"
                    :show-total="showTotal"
                    :total-label="totalLabel"
                />
            </div>
        </template>
    </div>
</template>
<script>
import RPTooltip from 'components/Basic/Misc/RPTooltip.vue';
import RPDonutChart from './RPDonutChart.vue';
import stat from 'status';
import statusBuilder from 'status/statusBuilder';

export default {
    name: 'MultiDonutCard',
    components: {
        RPTooltip,
        RPDonutChart
    },
    props: {
        header: {
            type: String,
            required: true
        },
        headerTooltip: {
            type: String,
            default: ''
        },
        chartData: {
            type: Array,
            required: true
        },
        showLegend: {
            type: Boolean,
            default: true
        },
        legendPosition: {
            type: String,
            default: 'bottom',
            validator: val => ['bottom', 'left', 'right'].indexOf(val) !== -1,
        },
        showTotal: {
            type: Boolean,
            default: true
        },
        totalLabel: {
            type: String,
            default: 'Reviews'
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },
        cardClass(){
            return statusBuilder('MultiDonutCard', this.status);
        },
    }
};
</script>
<style lang="scss">
    .MultiDonutCard {
        border-radius: 4px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        display: flex;
        flex-direction: column;

        @include loading(100%, 100%);

        &__header-bar {
            padding: 1rem 1rem 0 1rem;
            display: flex;
        }
        &__header {
            flex-grow: 1;
            display: flex;
            align-items: center;
        }
        &__header-text {
            color: $text-dark;
            font-weight: 600;
        }
        &__header-tooltip {
            margin-left: 0.25rem;
        }
        &__content {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: auto 0;
        }
    }
</style>
